package com.parmartechnologies.core.feature.business.network

import com.parmartechnologies.core.feature.address.model.Address
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RetrieveBusinessRequest(
    @SerialName("user_id") val UserID: String,
    @SerialName("mobile_number") val MobileNumber: String,
    @SerialName("dial_code") val dialCode: String,
)

@Serializable
data class RetrieveSingleBusinessRequest(
    @SerialName("_id") val id: String = "",
    @SerialName("Number") val number: Long = 0,
)

@Serializable
data class CreateBusinessRequest(
    @SerialName("business_type_id") val businessTypeID: String,
    @SerialName("user_id") val UserID: String,
    @SerialName("UserName") val UserName: String,
    @SerialName("mobile_number") val MobileNumber: String,
    @SerialName("dial_code") val dialCode: String,
    @SerialName("country_code") val countryCode: String,
    @SerialName("email_id") val email: String,
    @SerialName("name") val name: String,
    @SerialName("address") val Address: Address,
    @SerialName("note_one") val noteOne: String,
    @SerialName("note_two") val noteTwo: String,
)
@Serializable
data class UpdateBusinessRequest(
    @SerialName("_id") val _id: String,
    @SerialName("mobile_number") val mobile: String,
    @SerialName("dial_code") val dialCode: String,
    @SerialName("email_id") val email: String,
    @SerialName("name") val name: String,
    @SerialName("address") val address: Address,
)

@Serializable
data class FindBusinessRequest(
    @SerialName("user_id") val UserID: String,
    @SerialName("mobile_number") val mobile: String,
    @SerialName("dial_code") val dialCode: String,
)

@Serializable
data class FindNearbyBusinessRequest(
    @SerialName("user_id") val UserID: String,
    @SerialName("Latitude") val latitude: Double,
    @SerialName("Longitude") val longitude: Double,
)